import { ActionType } from 'Types/common';
import * as types from './types';

export const stopPollingAction = (): ActionType<undefined> => ({
  type: types.STOP_POLLING_TYPE,
});

export const fetchSagaAction = (
  type: string,
  payload?: Record<string, unknown>
): ActionType<Record<string, unknown>> => ({
  type,
  payload,
});
